import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message-contents-field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-7 m-bottom-12" }, " This message will be visible to staff only and will only post to the request timeline. ", -1)
const _hoisted_3 = {
  key: 0,
  class: "pin-checkbox-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_nr_editor = _resolveComponent("nr-editor")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_message_box = _resolveComponent("message-box")!

  return ($options.displayNoteMsgBox)
    ? (_openBlock(), _createBlock(_component_message_box, {
        key: 0,
        title: "New note",
        "submit-text": "Send notes",
        type: "orange",
        "disable-submit": $data.message ? false : true,
        onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDisplayMsgBox(false))),
        onOnCancel: $options.handleCancelMessage,
        onOnSubmit: $options.handleSubmitMessage
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_NrFormLabel, null, {
              default: _withCtx(() => [
                _createTextVNode("Note contents")
              ]),
              _: 1
            }),
            _createVNode(_component_nr_editor, {
              modelValue: $data.message,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.message) = $event)),
              resizable: false,
              placeholder: 'Type your message here.',
              rows: 10,
              strike: "",
              bulletList: "",
              orderedList: "",
              link: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _hoisted_2,
            ($options.shouldShowPinOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_NrFormInput, {
                    onChange: $options.changedPin,
                    class: "pin-checkbox",
                    label: "Pin this note above the timeline",
                    type: "checkbox",
                    "aria-labelledby": "pin-note-label",
                    "aria-label": "Pin this note above the timeline"
                  }, null, 8, ["onChange"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["disable-submit", "onOnCancel", "onOnSubmit"]))
    : _createCommentVNode("", true)
}